import * as React from 'react';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { formatPrice } from '../../utils/numberFormatter';
import useInvoices from '../../hooks/invoices/useInvoices';
import { isNullOrUndefined } from '../../utils/utils';
import { styled } from '@mui/material/styles';
import useUserSWR from '../../hooks/user/useUserSWR';
import usePaymentOptionsSWR from '../../hooks/usePaymentOptions';

const FilterBox = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    paddingBottom: '10px',
}));

const FilterTypo = styled(Typography)(() => ({
    cursor: 'pointer',
    fontWeight: '600',
}));

const FilterDeleteTypo = styled(Typography)(() => ({
    cursor: 'pointer',
    fontWeight: '600',
    color: '#FF4C4C',
}));

export const InvoicesInformation: React.FC<{
    handleFilter?: (type) => void;
    displayType: 'PROFILE' | 'INVOICE';
}> = (props) => {
    const { t } = useTranslation('invoices', {
        keyPrefix: 'INVOICES',
    });
    const { t: dt } = useTranslation();
    const { handleFilter, displayType } = props;
    const balance = useInvoices();
    const user = useUserSWR();
    const { payments } = usePaymentOptionsSWR();
    const [filteredItem, setFilteredItem] = React.useState(null);

    const { balances, isLoading, isError } = balance.useInvoicesBalanceSWR();

    if (isLoading || isError || isNullOrUndefined(balances)) {
        return <></>;
    }

    const handleBalanceFilter = (type) => {
        handleFilter(type);
        setFilteredItem(type);
    };

    const handleFilterDelete = () => {
        handleFilter(null);
        setFilteredItem(null);
    };

    const getPaymentsName = (userPayment) => {
        return payments && userPayment
            ? payments.find((elem) => elem.code == userPayment)?.description
            : userPayment;
    };

    return (
        <Box sx={{ paddingBottom: '10px' }}>
            {!isNullOrUndefined(balances.overDueBalance) &&
                displayType == 'INVOICE' && (
                    <FilterBox>
                        <Typography>
                            {t('OVER_DUE_BALANCE', {
                                number:
                                    formatPrice(
                                        Number(balances.overDueBalance)
                                    ) + ' Ft',
                            })}
                        </Typography>

                        {filteredItem == 'overDue' && (
                            <FilterDeleteTypo onClick={handleFilterDelete}>
                                {t('DELETE_FILTER')}
                            </FilterDeleteTypo>
                        )}
                        {(isNullOrUndefined(filteredItem) ||
                            filteredItem != 'overDue') && (
                            <FilterTypo
                                onClick={() => handleBalanceFilter('overDue')}
                            >
                                {t('FILTER')}
                            </FilterTypo>
                        )}
                    </FilterBox>
                )}
            {!isNullOrUndefined(balances.balance) && displayType == 'INVOICE' && (
                <FilterBox>
                    <Typography>
                        {t('BALANCE_DUE', {
                            number:
                                formatPrice(Number(balances.balance)) + ' Ft',
                        })}
                    </Typography>

                    {filteredItem == 'balance' && (
                        <FilterDeleteTypo onClick={handleFilterDelete}>
                            {t('DELETE_FILTER')}
                        </FilterDeleteTypo>
                    )}
                    {(isNullOrUndefined(filteredItem) ||
                        filteredItem != 'balance') && (
                        <FilterTypo
                            onClick={() => handleBalanceFilter('balance')}
                        >
                            {t('FILTER')}
                        </FilterTypo>
                    )}
                </FilterBox>
            )}
            {!isNullOrUndefined(balances.creditLimit) && (
                <Box>
                    <Typography gutterBottom>
                        {t('CREDIT_LIMIT', {
                            number:
                                formatPrice(
                                    Number(balances.creditLimit) < 20
                                        ? 0
                                        : Number(balances.creditLimit)
                                ) + ' Ft',
                        })}
                    </Typography>
                </Box>
            )}
            {!isNullOrUndefined(balances.commissionBalance) &&
                balances.commissionBalance > 0 && (
                    <Box>
                        <Typography gutterBottom>
                            {t('COMMISSION_BALANCE', {
                                number:
                                    formatPrice(
                                        Number(balances.commissionBalance)
                                    ) + ' Ft',
                            })}
                        </Typography>
                    </Box>
                )}
            {!isNullOrUndefined(user?.user?.default_payment_method) && (
                <Box>
                    <Typography gutterBottom>
                        {dt('PROFILE.PROFILE_CONTENT.PAYMENT')}:{' '}
                        {getPaymentsName(user.user.default_payment_method)}
                    </Typography>
                </Box>
            )}
        </Box>
    );
};
